import type { IconSvgObject } from './types';

const Parabola02Icon: IconSvgObject = [
  ["path", { d: "M21 2C21 10.2843 16.9706 17 12 17C7.02944 17 3 10.2843 3 2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 20H4.05882M15.7059 20H16.7647M19.9412 20H21M7.23529 20H8.29412", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 4.5C11.1 2.68572 11.45 2 12 2M14.5 4.5C12.9 2.68572 12.55 2 12 2M12 2V22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default Parabola02Icon;
